export const QuestionColorMap: string[] = [
  'MountFinishColor',
  'DropTubeFinishColor',
  'HubLogoPlateFinishColor',
  'AirfoilFinishColor',
  'WingletFinishColor',
];
